/*
  FormattedMessages.js - FormattedMessages for editComponent within Single View Customer of topuser reports Component

  Author: Julius Klaebe (2019)
  Company: Virtual Ark
*/

// NPM MODULES
import { FormattedMessage } from 'react-intl';
import React from 'react';

const FormattedMessages = {
  accountID: (
    <FormattedMessage id="Global.AccountID" defaultMessage="Account ID" />
  ),
  searchForACustomer: (
    <FormattedMessage
      id="Global.searchForACustomer"
      defaultMessage="Search for a Customer"
    />
  ),
  searchForUser: (
    <FormattedMessage
      id="Global.searchForUser"
      defaultMessage="Search for a User"
    />
  ),
  name: <FormattedMessage id="Global.Name" defaultMessage="Name" />,
  domain: <FormattedMessage id="Global.Domain" defaultMessage="Domain" />,
  authCode: (
    <FormattedMessage
      id="Global.AuthenticationCode"
      defaultMessage="Authentication Code"
    />
  ),
  ipAddress: (
    <FormattedMessage id="Global.IPAddress" defaultMessage="IP Address" />
  ),
  find: <FormattedMessage id="Global.Find" defaultMessage="Find" />,
  searchForAUser: (
    <FormattedMessage
      id="Global.SearchForAUser"
      defaultMessage="Search for a User"
    />
  ),
  userID: <FormattedMessage id="Global.UserID" defaultMessage="User ID" />,
  email: <FormattedMessage id="Global.Email" defaultMessage="Email" />,
  cell: (
    <FormattedMessage id="Global.CellNumber" defaultMessage="Cell Number" />
  ),
  searchForAnAdmin: (
    <FormattedMessage
      id="Global.SearchForAnAdministrator"
      defaultMessage="Search for an Administrator"
    />
  ),
  findAnErrorByEmail: (
    <FormattedMessage
      id="Global.FindAnErrorByEmail"
      defaultMessage="Find an Error by email recipient"
    />
  ),
  findMessagesViaDestNum: (
    <FormattedMessage
      id="Global.FindMessagesViaDestNum"
      defaultMessage="Find Messages via the destination number"
    />
  ),
  needToIncludeCountryCodeAndCell: (
    <FormattedMessage
      id="Global.NeedToIncludeCountryCodeAndCell"
      defaultMessage="You need to include the country code followed by the mobile phone number."
    />
  ),
  destNumb: (
    <FormattedMessage
      id="Global.DestNumb"
      defaultMessage="Destination Number"
    />
  ),
  noResultsFound: (
    <FormattedMessage
      id="Global.NoResultsFound"
      defaultMessage="No Results Found"
    />
  ),
  errorReturningResults: (
    <FormattedMessage
      id="Global.ErrorReturningResults"
      defaultMessage="Error Returning Results"
    />
  ),
  providerName: (
    <FormattedMessage
      id="Global.ProviderName"
      defaultMessage="Provider Name"></FormattedMessage>
  ),
  customerName: (
    <FormattedMessage
      id="Global.CustomerName"
      defaultMessage="Customer Name"></FormattedMessage>
  ),
  type: (
    <FormattedMessage id="Global.Type" defaultMessage="Type"></FormattedMessage>
  ),
  class: (
    <FormattedMessage
      id="Global.Class"
      defaultMessage="Class"></FormattedMessage>
  ),
  status: (
    <FormattedMessage
      id="Global.Status"
      defaultMessage="Status"></FormattedMessage>
  ),
  userName: (
    <FormattedMessage
      id="Global.UserName"
      defaultMessage="User Name"></FormattedMessage>
  ),
  userEmail: (
    <FormattedMessage
      id="Global.UserEmail"
      defaultMessage="User Email"></FormattedMessage>
  ),
  userPhone: (
    <FormattedMessage
      id="Global.UserPhone"
      defaultMessage="User Phone"></FormattedMessage>
  ),
  softVersion: (
    <FormattedMessage
      id="Global.SoftwareVersion"
      defaultMessage="Software Version"></FormattedMessage>
  ),
  contactName: (
    <FormattedMessage
      id="Global.ContactName"
      defaultMessage="Contact Name"></FormattedMessage>
  ),
  contactEmail: (
    <FormattedMessage
      id="Global.ContactEmail"
      defaultMessage="Contact Email"></FormattedMessage>
  ),
  contactPhone: (
    <FormattedMessage
      id="Global.contactPhone"
      defaultMessage="Contact Phone"></FormattedMessage>
  ),
  contactDepartment: (
    <FormattedMessage
      id="Global.ContactDepartment"
      defaultMessage="Contact Department"></FormattedMessage>
  ),
  accessLevel: (
    <FormattedMessage
      id="Global.AccessLevel"
      defaultMessage="Access Level"></FormattedMessage>
  ),
  destinationEmail: (
    <FormattedMessage
      id="Global.DestinationEmail"
      defaultMessage="Destination Email"></FormattedMessage>
  ),
  body: (
    <FormattedMessage id="Global.Body" defaultMessage="Body"></FormattedMessage>
  ),
  phone: (
    <FormattedMessage
      id="Global.Phone"
      defaultMessage="Phone"></FormattedMessage>
  ),
  maxDailyMessage: (
    <FormattedMessage
      id="Global.MaxDailyMessage"
      defaultMessage="Max. Msgs Per Day"></FormattedMessage>
  ),
  costCenter: (
    <FormattedMessage
      id="Global.CostCenter"
      defaultMessage="Cost Center"></FormattedMessage>
  ),
};

export default FormattedMessages;
